import { EVENT_BASIC_FORM_VALIDATIONS_SET_STATE, EVENT_BASIC_FORM_VALIDATIONS_STATE } from './actions'
import { IHubEventBasicFormValidationState, IHubEventBasicFormValidationStateAction } from './contracts'

export const HubEventBasicFormValidationReducer = (
  state: IHubEventBasicFormValidationState = EVENT_BASIC_FORM_VALIDATIONS_STATE,
  action: IHubEventBasicFormValidationStateAction
): any => {
  switch (action.type) {
    case EVENT_BASIC_FORM_VALIDATIONS_SET_STATE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
